<template>
  <div class="edit-link">
    <label class="main-title">リンク</label>
    <button @click="isShowLinkSetter = true"><i class="fas fa-pen"></i></button>
    <portal v-if="isShowLinkSetter" to="modal1">
      <edit-link-popup
        :ids="ids"
        :defaultAttrs="attrs"
        :partsContainerType="partsContainerType"
        @changeCodePartLink="changeCodePartLink($event)"
        @close="isShowLinkSetter = false"
      />
    </portal>
    <!-- none -->
    <div v-if="!attrs || !attrs['data-link-kind']">
      <p>未設定</p>
    </div>
    <!-- none -->
    <!-- web -->
    <div v-if="attrs && attrs['data-link-kind'] === 'web'">
      <label>WebサイトURL</label>
      <div class="flex">
        <p class="display-box">{{attrs.href}}</p>
        <!-- クリップボードにコピー -->
        <edit-link-copy-button
          :copyText="attrs.href"
          :target="'URL'"
        />
      </div>
    </div>
    <!-- web -->
    <!-- email -->
    <div class="email-box" v-if="attrs && attrs['data-link-kind'] === 'email'" >
      <div>
        <label>メールアドレス</label>
        <div class="flex">
          <p class="display-box">{{email.to}}</p>
          <!-- クリップボードにコピー -->
          <edit-link-copy-button
            :copyText="email.to"
            :target="'メールアドレス'"
          />
        </div>
      </div>
      <div v-if="email.subject" class="display-box">
        <label>メールタイトル</label>
        <p>{{email.subject}}</p>
      </div>
      <div v-if="email.body" class="display-box">
        <label>メール本文</label>
        <p>{{email.body}}</p>
      </div>
    </div>
    <!-- email -->
    <!-- tel -->
    <div v-if="attrs && attrs['data-link-kind'] === 'tel'">
      <label>電話番号</label>
      <div class="flex">
        <p class="display-box">{{attrs.href.replace(/^tel:/, '')}}</p>
        <!-- クリップボードにコピー -->
        <edit-link-copy-button
          :copyText="attrs.href.replace(/^tel:/, '')"
          :target="'電話番号'"
        />
      </div>
    </div>
    <!-- tel -->
  </div>
</template>

<script>
import EditLinkPopup from '@/components/Content/Palette/EditPartDesign/Layouts/EditLinkPopup'
import EditLinkCopyButton from '@/components/Content/Palette/EditPartDesign/Layouts/EditLinkCopyButton'
import { parseMailHref } from '@/utils/String'

export default {
  props: [
    'ids',
    'attrs',
    'partsContainerType',
  ],
  components: {
    EditLinkPopup,
    EditLinkCopyButton,
  },
  data () {
    return {
      isShowLinkSetter: false,
    }
  },
  computed: {
    email () {
      return this.attrs && this.attrs['data-link-kind'] === 'email' ? { ...parseMailHref(this.attrs.href) } : {}
    }
  },
  methods: {
    changeCodePartLink (event) {
      this.$emit('change', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-link {
  font-size: 14px;
  overflow: hidden;
  width: 100%;
  padding: 10px 0 10px 0;
  button {
    margin-left: 10px;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
  }
  p {
    color: rgba($baseFontColor, 0.3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  label:not(.main-title) {
    font-size: 12px;
  }
  .flex {
    display: flex;
  }
}
.email-box {
  > div {
    margin-bottom: 10px;
  }
}
// URL,メールアドレス,メールタイトル,メール本文,電話番号表示欄
.display-box {
  max-width: 340px;
}
</style>
